import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsList from "../pages/news/page";
import AnimeList from "../pages/anime/page";
import NewsDetail from "../pages/news/detail/page";
import AnimeDetail from "../pages/anime/detail/page";
import SearchPage from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <NewsList />,
  },
  {
    path: "/news/detail/:id",
    element: <NewsDetail />,
  },
  {
    path: "/anime",
    element: <AnimeList />,
  },
  {
    path: "/anime/detail/:id",
    element: <AnimeDetail />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;